import { FC } from 'react';

// Utils
import { defaultHandleTeamClick, classNames } from '@sportal365/smp-widget-utils';

// Types
import { ISubscriberInfo } from '../../../../../../packages/types';

interface Props {
  id: string;
  image?: string;
  name?: string;
  url: string;
  urlTarget?: string;
  className: string;
  isClickable?: boolean;
  handleClick: (info: ISubscriberInfo, clickType: string) => void;
}

const TeamInfo: FC<Props> = ({ id, image, name, url, urlTarget, className, isClickable = true, handleClick }) => {
  const handleSubscriptionEventClick = () => {
    isClickable && defaultHandleTeamClick(handleClick, { id, name: name ?? '' });
  };

  return (
    <a
      href={url}
      target={urlTarget}
      onClick={handleSubscriptionEventClick}
      className={classNames({
        'flex gap-2 items-center text-playerSecondaryTextColor hover:text-hiContrast no-underline hover:underline pointer-events-none':
          true,
        'text-hiContrast underline cursor-pointer pointer-events-auto': isClickable,
      })}
    >
      {image && (
        <img
          src={image}
          className={classNames(
            {
              'h-6 w-6 rounded-6': true,
            },
            `${className}-team-img`,
          )}
        />
      )}
      <span className={`${className}-team-name`}>{name}</span>
    </a>
  );
};

export default TeamInfo;
